/**
 * OVERRIDE TitleBlockView.jsx
 * REASON: Add `About text to the title block`
 * FILE VERSION: Volto 15.11.1
 * DATE: 2025-02-13
 * DEVELOPER: @iFlameing
 */

/**
 * View title/description block.
 * @module volto-slate/blocks/Title/TitleBlockView
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/**
 * View title block component.
 * @class View
 * @extends Component
 */
const TitleBlockView = ({ properties, metadata, className, formFieldName }) => {
  const Comp = formFieldName === 'title' ? 'h1' : 'p';
  const type = properties?.['@type']; // This is added for type.

  return (
    <Comp className={className}>
      {/* BEGIN CUSTOMIZATION */}
      {type === 'Author' ? (
        <>
          <FormattedMessage id="About" defaultMessage="About" />{' '}
          {(metadata || properties)[formFieldName] || ''}
        </>
      ) : (
        (metadata || properties)[formFieldName] || ''
      )}
      {/* END CUSTOMIZATION */}
    </Comp>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
TitleBlockView.propTypes = {
  properties: PropTypes.objectOf(PropTypes.any).isRequired,
  metadata: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string.isRequired,
  formFieldName: PropTypes.string.isRequired,
};

export default TitleBlockView;
